export default "__VITE_ASSET__BpCDCwCP__"